import { useCallback, useState } from 'react';

export function useHistorique<T>(initial: T) {
  const [historique, setHistorique] = useState({
    passes: [] as T[],
    present: initial,
    futurs: [] as T[],
  });
  const modifier = useCallback((valeur: T) => {
    setHistorique((h) =>
      JSON.stringify(h.present) === JSON.stringify(valeur)
        ? h
        : { passes: [...h.passes, h.present], present: valeur, futurs: [] },
    );
  }, []);
  const annuler = useCallback(
    () =>
      setHistorique((h) => {
        const precedent = h.passes.at(-1);
        return precedent === undefined
          ? h
          : { passes: h.passes.slice(0, -1), present: precedent, futurs: [h.present, ...h.futurs] };
      }),
    [],
  );
  const retablir = useCallback(
    () =>
      setHistorique((h) => {
        const suivant = h.futurs[0];
        return suivant === undefined
          ? h
          : { passes: [...h.passes, h.present], present: suivant, futurs: h.futurs.slice(1) };
      }),
    [],
  );
  return {
    valeur: historique.present,
    modifier,
    annuler,
    retablir,
    peutAnnuler: historique.passes.length > 0,
    peutRetablir: historique.futurs.length > 0,
  };
}
